// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import StripePaymentController from "./stripe_payment_controller"
application.register("stripe-payment", StripePaymentController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import PaywallPricingController from "./paywall_pricing_controller"
application.register("paywall-pricing", PaywallPricingController)

import SlackSettingsController from "./slack_settings_controller"
application.register("slack-settings", SlackSettingsController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import NestedCategoriesController from "./nested_categories_controller"
application.register("nested-categories", NestedCategoriesController)

import LabelInventoryController from "./label_inventory_controller"
application.register("label-inventory", LabelInventoryController)

import DashboardRangeController from "./dashboard_range_controller"
application.register("dashboard-range", DashboardRangeController)
